export const WORKOUT_MODES = {
  GROUPED: "grouped",
  FOLLOW_ALONG: "follow_along",
} as const;
